// extracted by mini-css-extract-plugin
export var attribution = "_cj-4";
export var authorName = "_cj-5";
export var quote = "_cj-3";
export var testimonial = "_cj-2";
export var trustedBy = "_cj-0";
export var trustedByLabel = "_cj-1";